export default "__VITE_ASSET__68d51764__"